/**
 * Responsive styles using MUI theme.breakpoints (built-in).
 * All breakpoints come from muiTheme.js - no raw @media.
 * Uses: theme.breakpoints.down() / up() → MUI GlobalStyles.
 */
export const getResponsiveStyles = (theme) => {
  const d = theme.breakpoints.down.bind(theme.breakpoints);
  const u = theme.breakpoints.up.bind(theme.breakpoints);
  return {
    /* Right content wrapper, Landing, LeftNav, UserSearchBar - md=900px */
    [d("md")]: {
      ".right-content-wrapper.responsive-wrapper, .right-content-wraper.responsive-wrapper": {
        marginLeft: "0 !important",
        width: "100% !important",
      },
      ".landing-content-wrapper.right-content-wrapper, .landing-content-wrapper.right-content-wraper, div.landing-content-wrapper":
        { paddingTop: "12px !important", paddingLeft: "12px !important" },
      ".MuiDrawer-root.MuiDrawer-temporary": { minWidth: "0 !important" },
      ".logo-wrapper, .logo-inr-wrap, .top-bar .logo": {
        marginLeft: "25px !important",
        transition: "margin-left 0.3s ease",
      },
      ".user-info-page.content-wrapper": {
        maxWidth: "100% !important",
        minWidth: "0 !important",
      },
      ".user-info-page .container": {
        maxWidth: "100% !important",
        minWidth: "0 !important",
      },
      ".user-info-page-search-wrap": {
        minWidth: "0 !important",
        maxWidth: "100% !important",
      },
    },
    /* Content wrapper max-width - desktopLg=1280 */
    [d("desktopLg")]: {
      ".right-content-wrapper.responsive-wrapper.content-wrapper, .right-content-wraper.responsive-wrapper.content-wrapper":
        { maxWidth: "100% !important" },
    },
    /* ls-popup - mobile=720 */
    [d("mobile")]: {
      ".ls-popup": {
        top: "80px",
        height: "calc(100vh - 80px)",
        alignItems: "flex-start",
        overflowY: "auto",
        padding: "12px 0",
      },
      ".ls-popup .modal-reset": {
        width: "100%",
        maxWidth: "calc(100vw - 24px)",
        margin: "12px",
        flexShrink: 0,
        maxHeight: "calc(100vh - 80px - 24px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      },
      ".ls-popup .modal-reset .modal-content": {
        // Popup component uses `<div class="modal-content p-0 pin-top">`.
        // `.p-0` sets `padding: 0 !important`, so we must override with `!important`
        // to prevent the close "X" from overlapping the title text on small screens.
        padding: "10px 12px 12px !important",
        paddingTop: "44px !important",
        boxSizing: "border-box",
        overflowX: "hidden",
        overflowY: "auto",
        maxWidth: "100%",
        flex: "1 1 auto",
        minHeight: 0,
      },
      ".ls-popup .modal-reset .modal-close": {
        top: "8px",
        right: "8px",
        zIndex: 30,
        flexShrink: 0,
        overflow: "visible",
      },
      ".ls-popup .modal-reset .modal-close i, .ls-popup .modal-reset .modal-close .material-icons":
        { display: "block !important", fontSize: "26px", lineHeight: 1 },
      ".form-style-modal.p-25": {
        padding: "12px !important",
        boxSizing: "border-box",
        minWidth: 0,
      },
      ".form-style-modal .block-title.mb-20": { marginBottom: "12px !important" },
      ".form-style-modal .row": { marginBottom: "12px !important" },
      ".form-style-modal .input-field label.active": { marginBottom: "6px !important" },
      ".form-style-modal .wweek-box .name": { padding: "4px 12px", fontSize: "13px" },

      /* Device Firmware: firmware distribution legend (<=720) */
      ".firmware-distribution-chart-wrap .apexcharts-legend": {
        padding: "8px 0 !important",
      },
      ".firmware-distribution-chart-wrap .apexcharts-legend-text": {
        fontSize: "12px !important",
        fontWeight: 500,
      },
      ".firmware-distribution-chart-wrap .apexcharts-legend-marker": {
        width: "10px !important",
        height: "10px !important",
        marginRight: "6px !important",
      },
      ".firmware-distribution-chart-wrap .apexcharts-legend-series": {
        margin: "4px 8px 4px 0 !important",
      },
    },

    /* Device Firmware: firmware distribution legend (<=480) */
    [d(480)]: {
      ".firmware-distribution-chart-wrap .apexcharts-legend-text": {
        fontSize: "11px !important",
      },
    },
    /* Device details - desktopMd=1100 */
    [d("desktopMd")]: {
      ".search-device-page-container .search-filter-block .search-filter-filter": {
        flexDirection: "column",
        alignItems: "stretch",
      },
      ".search-device-page-container .search-filter-block .search-filter-controls": {
        flexWrap: "wrap",
      },
      ".search-device-page-container .search-filter-block .search-filter-type-select.MuiFormControl-root":
        { flex: "1 1 100% !important", maxWidth: "100% !important" },
    },
    /* Device details header & cols - desktop=1024 */
    [d("desktop")]: {
      ".device-details-header-left, .device-details-header-right": {
        flex: "0 0 100% !important",
        maxWidth: "100% !important",
      },
      ".device-details-header-right": { justifyContent: "flex-start", marginTop: "8px" },
      ".device-details-header-row .right-align": { justifyContent: "flex-start" },
      ".device-detail.user-information .row.mb-0 > .s6.col, .device-detail.user-information .row.mb-0 > .device-details-left-col, .device-detail.user-information .row.mb-0 > .device-details-right-col":
        {
          width: "100% !important",
          maxWidth: "100% !important",
          flex: "0 0 100% !important",
          marginBottom: 0,
        },
      ".device-detail.user-information .row.mb-0 > .device-details-right-col": {
        marginTop: "4px",
      },
      /* searchFilterLayout */
      ".search-filter-block .search-filter-filter": {
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        paddingRight: 0,
        paddingLeft: 0,
        boxSizing: "border-box",
      },
      ".search-filter-block .search-filter-controls": {
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "stretch",
        justifyContent: "flex-start",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 0,
        paddingRight: 0,
        gap: "12px",
        boxSizing: "border-box",
      },
      ".search-filter-block .search-filter-search-by": {
        flex: "0 0 100%",
        width: "100%",
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 0,
      },
      ".search-filter-block .search-filter-type-select": {
        flex: "0 0 100% !important",
        width: "100% !important",
        maxWidth: "100% !important",
        minWidth: "0 !important",
        marginLeft: "0 !important",
        marginRight: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        boxSizing: "border-box",
      },
      ".search-filter-block .search-filter-type-select.MuiFormControl-root": {
        flex: "0 0 100% !important",
        width: "100% !important",
        maxWidth: "100% !important",
        minWidth: "0 !important",
      },
      ".search-filter-block .search-filter-type-select .MuiOutlinedInput-root": {
        width: "100% !important",
        minWidth: "0 !important",
      },
      ".search-filter-block .search-filter-country-select": {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
      },
      ".search-filter-block .search-filter-form": {
        maxWidth: "100%",
        width: "100%",
        display: "flex",
        flexWrap: "nowrap",
        gap: 0,
      },
      ".search-filter-block.search-filter-united-field .search-filter-form": {
        flex: "1 1 0%",
        minWidth: 0,
        maxWidth: "none",
        width: 0,
      },
      ".search-filter-block.search-filter-united-field.search-filter-no-scan .search-filter-form":
        { flex: "0 0 100% !important", width: "100% !important" },
      ".search-filter-block.search-filter-united-field .search-filter-scan": {
        flex: "0 0 auto",
        flexShrink: 0,
        marginLeft: "8px",
      },
      ".search-filter-block.search-filter-united-field .search-filter-scan .fa-qrcode-search-device":
        { fontSize: "2em", display: "inline-block", lineHeight: 1 },
      ".search-filter-block .search-filter-input-wrap": {
        flex: "1 1 0%",
        minWidth: 0,
        width: 0,
        maxWidth: "none",
        marginLeft: "0 !important",
        marginRight: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        boxSizing: "border-box",
      },
      ".search-filter-block .search-filter-input-wrap + .search-filter-btn": {
        marginTop: 0,
        flex: "0 0 auto",
      },
      ".search-filter-block .search-filter-input-wrap .search-device, .search-filter-block .search-filter-input-wrap .search-device.not-found":
        {
          maxWidth: "100%",
          width: "100%",
          minWidth: 0,
          marginLeft: "0 !important",
          marginRight: "0 !important",
          paddingLeft: "0 !important",
          float: "none",
          boxSizing: "border-box",
        },
      ".search-filter-block .search-filter-input-wrap .search-device input.add-input, .search-filter-block .search-filter-input-wrap .search-device input[type=\"text\"], .search-filter-block .search-filter-input-wrap .search-device input[type=\"number\"]":
        { minWidth: "0 !important", width: "100%", flex: "1 1 auto" },
      ".search-filter-block .search-filter-input-wrap .search-device.no-left-pad input.add-input, .search-filter-block .search-filter-input-wrap .search-device.no-left-pad input[type=\"text\"]":
        { minWidth: "0 !important" },
      ".search-filter-block .search-filter-btn": { width: "auto", flexShrink: 0 },
      ".search-filter-block .search-filter-btn .btn, .search-filter-block .search-filter-btn input[type=\"button\"], .search-filter-block .search-filter-btn input[type=\"submit\"]":
        { width: "auto", minWidth: 0 },
      ".search-filter-block.get-dealer-info-filter .search-filter-input-wrap": {
        flex: "1 1 0",
        minWidth: 0,
        maxWidth: "none",
      },
      ".search-filter-block.get-dealer-info-filter .search-filter-input-wrap + .search-filter-btn":
        { marginLeft: "-1px" },
      ".search-filter-block.get-dealer-info-filter .search-filter-input-wrap .search-device, .search-filter-block.get-dealer-info-filter .search-filter-input-wrap .search-device.not-found":
        { borderRadius: "3px 0 0 3px" },
      ".search-filter-block.get-dealer-info-filter .search-filter-input-wrap .search-filter-country-select, .search-filter-block.get-dealer-info-filter .search-filter-input-wrap .search-filter-country-select .MuiOutlinedInput-root":
        { borderRadius: "3px 0 0 3px !important" },
      ".search-filter-block.get-dealer-info-filter .search-filter-btn .btn, .search-filter-block.get-dealer-info-filter .search-filter-btn input[type=\"button\"], .search-filter-block.get-dealer-info-filter .search-filter-btn input[type=\"submit\"]":
        { borderRadius: "0 3px 3px 0", marginLeft: "-1px" },
      ".search-filter-block.search-notification-filter .search-filter-type-select.MuiFormControl-root":
        {
          flex: "0 0 100% !important",
          width: "100% !important",
          maxWidth: "100% !important",
          minWidth: "0 !important",
        },
      ".search-filter-block.search-notification-filter .search-notification-input-btn-unit":
        {
          flex: "1 1 100% !important",
          width: "100% !important",
          maxWidth: "100% !important",
          minWidth: "0 !important",
        },
      ".search-filter-block.search-notification-filter .search-notification-input-btn-unit .search-filter-input-wrap":
        {
          flex: "1 1 0% !important",
          width: "100% !important",
          minWidth: "0 !important",
          maxWidth: "none !important",
        },
      ".search-filter-block.search-notification-filter .search-filter-input-wrap": {
        flex: "1 1 0%",
        minWidth: 0,
        width: 0,
        maxWidth: "none",
      },
      ".search-filter-block.search-notification-filter .search-filter-input-wrap + .search-filter-btn":
        { marginLeft: "-1px" },
      ".search-filter-block.search-notification-filter .search-filter-input-wrap .search-device, .search-filter-block.search-notification-filter .search-filter-input-wrap .search-device.not-found":
        { borderRadius: "3px 0 0 3px", width: "100%" },
      ".search-filter-block.search-notification-filter .search-filter-btn .btn, .search-filter-block.search-notification-filter .search-filter-btn input[type=\"button\"], .search-filter-block.search-notification-filter .search-filter-btn input[type=\"submit\"]":
        { borderRadius: "0 3px 3px 0", marginLeft: "-1px" },
      ".search-device input.add-input.md": {
        minWidth: "0 !important",
        maxWidth: "100%",
        flex: "1 1 auto",
      },
      /* ManufacturedDevices, DeviceFirmware */
      ".manufactured-devices-filter .MuiGrid-container.mb-0": { overflow: "visible" },
      ".manufactured-devices-filter .MuiGrid-container > .MuiGrid-item:first-of-type": {
        position: "relative",
        zIndex: 2,
        marginBottom: "8px",
      },
      ".manufactured-devices-filter .MuiGrid-container > .MuiGrid-item:first-of-type .model-srch":
        { position: "relative", zIndex: 2 },
      ".device-firmware-filter .py-15": { overflow: "visible" },
      ".device-firmware-filter .row.mb-0": {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "stretch",
        gap: "12px",
        marginLeft: 0,
        marginRight: 0,
      },
      ".device-firmware-filter .row.mb-0 .col": {
        flex: "0 0 100%",
        maxWidth: "100%",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        paddingLeft: 0,
        paddingRight: 0,
      },
      ".device-firmware-filter .row.mb-0 .col.pt-10": { paddingTop: 0 },
      ".device-firmware-filter .row.mb-0 .col .model-srch.reset.width-md, .device-firmware-filter .row.mb-0 .col .MuiFormControl-root":
        {
          width: "100% !important",
          maxWidth: "100% !important",
          minWidth: "0 !important",
        },
      ".device-firmware-filter .row.mb-0 .col .btn.btn-style-2.orange-bg": {
        marginLeft: 0,
        marginRight: "12px",
        marginBottom: 0,
      },
      ".device-firmware-filter .row.mb-0 .col .btn.btn-style-2.orange-bg:last-child":
        { marginRight: 0 },
    },
    /* Desktop only - min-width */
    [u("desktopUp")]: {
      ".search-device input.add-input.md": {
        minWidth: "220px !important",
        maxWidth: "100%",
        flex: "1 1 auto",
      },
    },
    /* tablet=768 */
    [d("tablet")]: {
      ".device-status .row .s6.col": {
        width: "100% !important",
        maxWidth: "100% !important",
      },
      ".statistics-download-table": { minWidth: "280px" },
      ".statistics-download-table .statistics-col-category": { minWidth: "120px" },
      ".statistics-download-table .statistics-col-download": { minWidth: "80px" },
      ".firmware-distribution-row .firmware-distribution-chart-col, .firmware-distribution-row .firmware-distribution-summary-col":
        {
          width: "100% !important",
          maxWidth: "100% !important",
          flex: "0 0 100% !important",
          boxSizing: "border-box",
        },
      ".firmware-distribution-summary-col": { marginTop: "16px" },
      ".firmware-distribution-chart-wrap": {
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
      },
      ".add-new-device-model-wrap .row .col, .add-new-device-model-wrap .row .s4.col": {
        width: "100% !important",
        maxWidth: "100% !important",
        flex: "0 0 100% !important",
        marginBottom: "16px",
        boxSizing: "border-box",
      },
      ".add-new-device-model-wrap .row .col:last-child, .add-new-device-model-wrap .row .s4.col:last-child":
        { marginBottom: "4px" },
      ".add-new-device-model-wrap .row": {
        marginBottom: "12px",
        display: "flex",
        flexWrap: "wrap",
      },
      ".add-new-device-model-wrap .row .mb-15": {
        marginBottom: "16px !important",
      },
      ".add-new-device-model-wrap .add-new-device-model-upload-wrap": {
        float: "none",
        marginTop: "12px",
        marginBottom: "16px",
      },
      ".add-new-device-model-wrap .add-new-device-model-first-row-spacer": {
        display: "none",
      },
    },
    /* tabletUp=769 */
    [u("tabletUp")]: {
      ".device-status .row .s6.col": { width: "50%" },
    },
    /* sm=600 - Report page, add-new-device-model: content from left, full width on mobile */
    [d("sm")]: {
      ".add-new-device-model-wrap .MuiCardContent-root": {
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
        overflowX: "hidden",
      },
      ".add-new-device-model-wrap .py-15": {
        paddingTop: "8px",
        paddingBottom: "8px",
      },
      ".add-new-device-model-wrap .add-input.xl": {
        maxWidth: "100%",
        boxSizing: "border-box",
      },
      ".report-page-wrapper.right-content-wrapper.responsive-wrapper": {
        paddingLeft: "4px !important",
        paddingRight: "4px !important",
      },
      ".report-page-wrapper .user-report-wrap": {
        maxWidth: "100% !important",
        marginLeft: "0 !important",
      },
      ".report-page-wrapper .user-report-wrap .row": {
        marginLeft: "0 !important",
        marginRight: "0 !important",
        maxWidth: "100% !important",
      },
      ".report-page-wrapper .user-report-wrap .col": {
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
      },
      ".report-page-wrapper .content-block": {
        maxWidth: "100% !important",
        marginLeft: "0 !important",
        marginRight: "0 !important",
        paddingLeft: "4px !important",
        paddingRight: "4px !important",
      },
      ".report-page-wrapper .report-devices-page": {
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        maxWidth: "100% !important",
      },
      ".report-page-wrapper .p-15": {
        paddingLeft: "4px !important",
        paddingRight: "4px !important",
      },
      ".report-page-wrapper .MuiPaper-root": {
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
      },
      ".report-page-wrapper .child-devices-section": {
        paddingLeft: "0 !important",
      },
      ".report-page-wrapper .vrf-child-devices-card": {
        paddingLeft: "12px !important",
        paddingRight: "12px !important",
      },
      ".px-70": {
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
      },
      ".device-firmware-filter .row.mb-0 .col": {
        flex: "0 0 100%",
        maxWidth: "100%",
      },
      ".device-firmware-filter .btn.btn-style-2.orange-bg": {
        minHeight: "40px !important",
        height: "40px !important",
      },
      ".wweek-box .name": { padding: "6px 14px", fontSize: "13px" },
      ".form-style-modal .row .input-field.col.s5, .form-style-modal .row .input-field.col.s2":
        {
          width: "100%",
          maxWidth: "100%",
          marginLeft: 0,
          marginBottom: "16px",
        },
      ".form-style-modal .row .input-field.col.s5:last-of-type, .form-style-modal .row .input-field.col.s2:last-of-type":
        { marginBottom: 0 },
      ".form-style-modal .select-wrapper": { width: "100%" },
      ".form-style-modal .control-capabilities .model-srch select, .form-style-modal .form-add-input":
        { width: "100%", maxWidth: "100%", boxSizing: "border-box" },
      ".form-style-modal .d-flex.flex-end": { flexWrap: "wrap", gap: "8px" },
      ".form-style-modal .d-flex.flex-end .btn": { minWidth: "100%" },
      ".feedback-filter-section .model-srch.reset.width-md": { width: "100%" },
      ".feedback-filter-section select.custom-select.select-reset, .feedback-filter-section .add-input.calendar.input_phone":
        {
          width: "100% !important",
          maxWidth: "100%",
          boxSizing: "border-box",
        },
      ".feedback-filter-section .btn.btn-style-2": { flex: "1 1 auto", minWidth: 0 },
      ".content-block.feedback-filter-section": { paddingTop: "10px" },
      ".feedback-filter-section .feedback-filter-inner": {
        paddingTop: "8px !important",
        paddingBottom: "14px !important",
      },
      ".feedback-filter-section .MuiGrid-container": { rowGap: "16px" },
      ".landing-card .landing-card-section-icon, .landing-card .landing-card-subitem-icon, .landing-card .landing-card-list .MuiListItemIcon-root":
        {
          width: "32px !important",
          minWidth: "32px !important",
          maxWidth: "32px !important",
        },
      ".landing-hero": { borderRadius: "12px" },
      ".landing-card": { borderRadius: "12px" },
      /* Report Incidence modal - sm=600px */
      ".MuiDialog-root .email-sending-popup .gray-section": {
        marginLeft: 0,
        marginRight: 0,
      },
      ".MuiDialog-root .email-sending-popup .editor.px-20": {
        paddingLeft: 0,
        paddingRight: 0,
      },
      ".MuiDialog-root .email-sending-popup .cke_contents.cke_reset": {
        height: 140,
      },
      ".MuiDialog-root .email-sending-popup .gray-section .unique-box .title": {
        fontSize: 11,
        display: "block",
      },
      ".MuiDialog-root .email-sending-popup .gray-section .unique-box .device-info": {
        fontSize: 12,
        wordBreak: "break-word",
      },
    },
    /* desktopSm=960 - notification */
    [d("desktopSm")]: {
      ".search-filter-block .search-filter-controls": { width: "100%", marginLeft: 0 },
      ".search-filter-block .search-filter-form, .search-filter-block .search-filter-input-wrap":
        { width: "100%", maxWidth: "100%" },
      ".send-notification-config-row > div": { flexBasis: "100%" },
      ".send-notification-config-row .field-input-wrap, .send-notification-config-row .send-notification-field-row > div, .send-notification-config-row .send-notification-field-row > .field-input-wrap":
        {
          flex: "1 1 auto !important",
          minWidth: "0 !important",
          maxWidth: "100% !important",
          width: "100% !important",
        },
      ".send-notification-users-block .send-notification-users-row > label": {
        flex: "0 0 200px",
        width: "200px",
        minWidth: "200px",
      },
      ".send-notification-users-block .send-notification-users-row > div": {
        flex: "1 1 auto",
        minWidth: 0,
        maxWidth: "100%",
      },
      ".send-notification-field-row > label": {
        flex: "0 0 200px",
        width: "200px",
        minWidth: "200px",
      },
      ".send-notification-field-row > div, .send-notification-field-row > .field-input-wrap":
        {
          flex: "1 1 auto",
          minWidth: 0,
          maxWidth: "100%",
        },
      ".send-notification-message .send-notification-field-row > div": {
        maxWidth: "100%",
      },
      ".send-notification-additional .send-notification-field-row > label": {
        flex: "0 0 200px",
        width: "200px",
        minWidth: "200px",
      },
      ".send-notification-additional .send-notification-field-row > div": {
        flex: "1 1 auto",
        minWidth: 0,
        maxWidth: "100%",
      },
      ".send-notification-config-row .send-notification-field-row, .send-notification-users-block > div, .send-notification-users-block .send-notification-users-row, .send-notification-additional .send-notification-field-row":
        { marginBottom: "16px !important" },
      ".send-notification-config-row .send-notification-field-row:last-child, .send-notification-users-block > div:last-child":
        { marginBottom: "0 !important" },
    },
    /* mobileXs=400 */
    [d("mobileXs")]: {
      ".send-notification-field-row > label, .send-notification-users-block .send-notification-users-row > label, .send-notification-additional .send-notification-field-row > label":
        {
          flex: "0 0 140px",
          width: "140px",
          minWidth: "140px",
        },
    },
    /* Login: tablet and below (theme breakpoint `tablet` = 768) */
    [d("tablet")]: {
      ".login-wrapper": {
        padding: "16px",
        boxSizing: "border-box",
      },
      ".login-wrapper .login-box .form-box": {
        padding: "24px",
      },
    },
    /* Login: small phones (<=480) - use dynamic viewport height where supported */
    [d(480)]: {
      ".login-wrapper": {
        padding: "12px",
        minHeight: "100dvh",
        height: "auto",
      },
      ".login-wrapper .login-box .form-box": {
        padding: "20px 16px",
      },
      ".mfa-page-title": {
        fontSize: "0.95rem",
      },
      /* Allow reCAPTCHA challenge UI to escape clipped ancestors on small screens */
      ".login-screen": {
        overflow: "visible",
      },
      ".login-screen .login-box, .login-screen .login-box .form-box": {
        overflow: "visible",
      },
    },

    /* Reduced motion support (media feature) */
    "@media (prefers-reduced-motion: reduce)": {
      ".right-content-wrapper.responsive-wrapper": {
        transition: "none !important",
      },
      ".MuiDrawer-paper, .MuiCollapse-root, .MuiListItemButton-root": {
        transition: "none !important",
      },
    },

    /* Print optimization */
    "@media print": {
      ".MuiDrawer-root, .MuiBackdrop-root": {
        display: "none !important",
      },
    },
  };
};
